/**
 * @author Vivek.Kumar <vivek.kumar@314ecorp.com>
 * @description component to ViewPortBlocker
 */
import { useEffect } from 'react';
import { Layout, Result } from 'antd';
import { BrowserRouterProps } from 'react-router-dom';

import { RESULT_TYPES } from 'components/widgets/AppResult';
import { removeElementFromDom } from 'utils/app';
import { MINIMUM_DESKTOP_VIEWPORT_WIDTH } from 'app-constants/index';

/**
 * ViewPortBlocker
 * @description component to handle errors
 */
const ViewPortBlocker: React.FC<BrowserRouterProps> = (props) => {
	const isMobile = globalThis.innerWidth < MINIMUM_DESKTOP_VIEWPORT_WIDTH;

	useEffect(() => {
		if (isMobile) {
			removeElementFromDom();
		}
	}, [isMobile]);

	if (isMobile) {
		return (
			<Layout>
				<Layout.Content style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<Result {...RESULT_TYPES.viewPortBlocker} />
				</Layout.Content>
			</Layout>
		);
	}

	return <>{props.children}</>;
};

export default ViewPortBlocker;
